/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 740181f27910
 */

import * as z from "zod";

/**
 * Width - integer pixels or string variable reference (e.g., "$w")
 */
export type Width = number | string;

export const Width$zodSchema: z.ZodType<Width> = z.union([
  z.int(),
  z.string(),
]).describe(
  "Width - integer pixels or string variable reference (e.g., \"$w\")",
);

/**
 * Height - integer pixels or string variable reference (e.g., "$h")
 */
export type Height = number | string;

export const Height$zodSchema: z.ZodType<Height> = z.union([
  z.int(),
  z.string(),
]).describe(
  "Height - integer pixels or string variable reference (e.g., \"$h\")",
);

export type Info = {
  width?: number | string | undefined;
  height?: number | string | undefined;
  crop?: string | undefined;
  gravity?: string | undefined;
};

export const Info$zodSchema: z.ZodType<Info> = z.object({
  crop: z.string().optional(),
  gravity: z.string().optional(),
  height: z.union([
    z.int(),
    z.string(),
  ]).optional().describe(
    "Height - integer pixels or string variable reference (e.g., \"$h\")",
  ),
  width: z.union([
    z.int(),
    z.string(),
  ]).optional().describe(
    "Width - integer pixels or string variable reference (e.g., \"$w\")",
  ),
});

export type Derived = {
  public_id?: string | undefined;
  resource_type?: string | undefined;
  type?: string | undefined;
  format?: string | undefined;
  url?: string | undefined;
  secure_url?: string | undefined;
  bytes?: number | undefined;
  id?: string | undefined;
};

export const Derived$zodSchema: z.ZodType<Derived> = z.object({
  bytes: z.int().optional(),
  format: z.string().optional(),
  id: z.string().optional(),
  public_id: z.string().optional(),
  resource_type: z.string().optional(),
  secure_url: z.string().optional(),
  type: z.string().optional(),
  url: z.string().optional(),
});

export type TransformationInfo = {
  name?: string | undefined;
  allowed_for_strict?: boolean | undefined;
  used?: boolean | undefined;
  named?: boolean | undefined;
  info?: Array<Info> | undefined;
  derived?: Array<Derived> | undefined;
  next_cursor?: string | undefined;
};

export const TransformationInfo$zodSchema: z.ZodType<TransformationInfo> = z
  .object({
    allowed_for_strict: z.boolean().optional().describe(
      "Whether to allow this named transformation when [strict transformations](https://cloudinary.com/documentation/control_access_to_media#strict_transformations) are enabled.\n",
    ),
    derived: z.array(z.lazy(() => Derived$zodSchema)).optional(),
    info: z.array(z.lazy(() => Info$zodSchema)).optional().describe(
      "API transformation parameters",
    ),
    name: z.string().optional(),
    named: z.boolean().optional(),
    next_cursor: z.string().optional(),
    used: z.boolean().optional(),
  });
